import {Store} from '@reduxjs/toolkit'
import axios from 'axios'
import {API_URL} from '../config/env'
import {RootState} from './redux'

export const setupAxios = (store: Store<RootState>) => {
  axios.interceptors.request.use((config) => {
    config.baseURL = API_URL
    const token = store.getState().auth.user.data?.token
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  })
}
